import script from "./UserGroupsAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./UserGroupsAdmin.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__